<template>
  <div class="fistpage">
    <v-layout>
      <v-flex xs3>
        <div class="title-header">{{ this.$t('index.system') }}</div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon
              style="font-size:58px!important; margin-bottom:20px;color:#1cade4!important"
              >mdi-apps</v-icon
            >
          </v-flex>
          <router-link to="data">
            <div>{{ this.$t('nav.data') }}</div></router-link
          >
        </div>
      </v-flex>
      <v-flex xs3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon
              style="font-size:58px!important; margin-bottom:20px;color:#1cade4!important"
              >mdi-settings</v-icon
            >
          </v-flex>
          <router-link to="system">
            <div>{{ this.$t('nav.system') }}</div></router-link
          >
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs3>
        <div class="title-header">{{ this.$t('index.data') }}</div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon
              style="font-size:58px!important; margin-bottom:20px;color:#1cade4!important"
              >mdi-finance</v-icon
            >
          </v-flex>
          <router-link to="report">
            <div>{{ this.$t('nav.report') }}</div></router-link
          >
        </div>
      </v-flex>
      <v-flex xs3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon
              style="font-size:58px!important; margin-bottom:20px;color:#1cade4!important"
              >mdi-alert-circle</v-icon
            >
          </v-flex>
          <router-link to="audit">
            <div>{{ this.$t('nav.audit') }}</div></router-link
          >
        </div>
      </v-flex>
    </v-layout>
    <core-confirm ref="myConfirm"></core-confirm>
  </div>
</template>
<style>
.item-cell {
  border: 1px solid #1cade4;
  margin-left: 30px;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 60px;
  border-radius: 10px;
  padding-top: 60px;
}
.item-cell :hover {
  cursor: pointer;
}
.other-meeting {
  color: blue;
}
.title-header {
  text-align: left;
  border-left: 5px solid #1cade4;
  margin-left: 30px;
  margin-top: 30px;
  padding-left: 10px;
  font-size: 16px;
  color: #1cade4;
}
.fistpage {
  margin-top: 72px;
}
</style>
<script>
import { mapState } from 'vuex'
import CoreConfirm from '@/components/core/confirm.vue'
export default {
  components: {
    CoreConfirm
  },
  data: () => ({}),
  mounted: function() {
    this.base.confirmDialog = this.$refs.myConfirm
  },
  computed: {
    ...mapState({
      base: state => state.base
    })
  },
  watch: {},
  methods: {}
}
</script>
